/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import { FooterMobile } from '../../Layout/DefaultLayout/FooterMobile'
import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './CaiDatMobile.scss'
import { DangXuat } from './DangXuat'
import { ChamSocKhachHang } from './ChamSocKhachHang'
import { getFromlocalstorage } from '../../component/MaHoaDuLieu/MaHoaDuLieu'
import { useUser } from '../../component/UserProvider/UserProvider'
import CheckRutTien from '../../component/CheckRutTien/CheckRutTien'
import CheckNapTien from '../../component/CheckNapTien/CheckNapTien'
import Loading from '../../component/Loading/Loading'

function CaiDatMobile () {
  const navigate = useNavigate()
  const [showLogoutPopup, setShowLogoutPopup] = useState(false)
  const [showChamSocKhachHang, setShowChamSocKhachHang] = useState(false)
  const apiUrl = process.env.REACT_APP_API_BACKEND
const hasFetched = useRef(false);
    const data_user = JSON.parse(getFromlocalstorage("data_u"));
    const { user, fetchUser } = useUser();
  const [isLoading, setisLoading] = useState(false)
    useEffect(() => {
      if (data_user && !hasFetched.current) {
        fetchUser(data_user._id);
        hasFetched.current = true;
      }
      
    }, [data_user]);
    const handleWithdraw = async () => {
    await CheckRutTien(navigate)
  }
  const handleDeposit = async () => {
    await CheckNapTien(navigate)
  }
  const handleRutTienGame = async () => {
    try {
      setisLoading(true)
      const response = await fetch(`${apiUrl}/withdraw-game`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data_user: data_user })
      })

      if (response.ok) {
        fetchUser(data_user._id)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setisLoading(false)
    }
  }
  const data = [
    {
      name: 'อัปเดตบัญชีธนาคาร/ที่อยู่กระเป๋าเงิน',
      icon: '/caidat/iconcdrut.png',
      link: '/addtkrutmobile'
    },
    {
      name: 'ประวัติฝาก-ถอน',
      icon: '/caidat/lichsunr.png',
      link: '/lichsunaprutmobile'
    },
    {
      name: 'แนะนำสมาชิก',
      icon: '/caidat/iconhoahong.png',
      link: '/hoahong'
    },
    // {
    //   name: 'Lịch sử cược',
    //   icon: '/caidat/iconlichsucuoc.png',
    //   link: '/lichsucuocmobile'
    // },
    {
      name: 'เปลี่ยนรหัสผ่าน',
      icon: '/caidat/icondoimk.png',
      link: '/repassmobile'
    }
    ,
    {
      name: 'บริการลูกค้า',
      icon: '/caidat/iconcskh.png',
      onClick: () => setShowChamSocKhachHang(true)
    }
    ,
    // {
    //   name: 'Liên hệ hỗ trợ',
    //   icon: '/caidat/iconlienhe.png',
    //   link: '/lienhehotro'
    // }
  ]
  return (
    <div className='cai_dat_mobile_tong'>
      <div className='div_wrap_router_cd'>
        <div className='router_view_cd'>
          <div className='list_cotainer_cd'>
            <div className='pull_to_cd'>
              <div className='scroll_cotainer_cd'>
                <div className='user_overview_cd'>
                  <div className='info_view_cd'>
                    <div className='div_info_cd'>
                      <div className='info_item_cd'>
                        <div className='info_img_cd'>
                          <img
                            src='/avatar.png'
                            alt=''
                            className='info_avatar_cd'
                          />
                          <img src='/vip.png' alt='' className='info_vip_cd' />
                        </div>
                      </div>
                      <div className='info_item_cd'>
                        <span className='p_name_cd'>
                          <label htmlFor='' className='label_name_cd ellipsis'>
                            {user?.username}
                          </label>
                          <div className='level_cd'>
                            <span className='prefix'>
                              <img
                                src='/iconvip1.png'
                                alt=''
                                style={{
                                  display: 'block',
                                  height: '100%'
                                }}
                              />
                            </span>
                            <span className='name_pt'>ทั่วไป</span>
                            <span className='suffix'>
                              <img
                                src='/vip1_right.png'
                                alt=''
                                style={{ display: 'block', height: '100%' }}
                              />
                            </span>
                          </div>
                        </span>
                        <p className='id_tv_cd'>รหัสสมาชิก：17260821</p>
                      </div>
                      <div className='user_ctrl_cd'>
                        <a href='' className='i_arrow_cd'>
                          <img
                            src='/iconarround.png'
                            alt=''
                            style={{ width: '0.88rem' }}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className='balance_wrapper_cd'>
                    <div className='balance_item_cd'>
                      <div className='balance_item_left'>
                        <p>ยอดเงิน</p>
                      </div>
                      <div className='balance_item_right'>
                        <p>
                          {user?.coins === 0
                            ? "0.00"
                            : Number(
                                (user?.coins || 0).toFixed(0)
                              ).toLocaleString("en-US") || 0}
                          <span> THB</span>
                        </p>
                        <img src='/iconreload.png' alt='' onClick={handleRutTienGame}/>
                      </div>
                    </div>
                  </div>
                </div>
                <ul className='cell_list_cd'>
                  <li className='gold-flow-wapper'>
                    <div
                      className='gold_item gold_item_left'
                      onClick={handleDeposit}
                    >
                      <i className='gtm_me_deposit'></i>
                      <span className='span_me_deposit'>ฝากเงิน</span>
                    </div>
                    <div
                      className='gold_item'
                      onClick={handleWithdraw}
                    >
                      <i className='gtm_me_withdraw'></i>
                      <span className='span_me_deposit'>ถอนเงิน</span>
                    </div>
                  </li>
                  <li className='dividing-line'></li>
                  <li className='national_agent'>
                    <img src='/moibanbe.png' alt='' />
                  </li>
                  <li
                    className='cd_item'
                    onClick={() => navigate('/khuyenmaimobile')}
                  >
                    <i className='yhhd_cd'></i>
                    <div className='gtm_me_bankcards'>
                          โปรโมชั่น
                      <img src='/caidat/arrow.png' alt='' />
                    </div>
                  </li>

                  {data.map((item, index) => (
                    <li
                      className='cd_item'
                      key={index}
                      onClick={() => {
                        if (item.link) {
                          navigate(item.link)
                        } else {
                          item.onClick()
                        }
                      }}
                    >
                      <img src={item.icon} alt='' />
                      <div className='gtm_me_bankcards'>
                        {item.name}
                        <img src='/caidat/arrow.png' alt='' />
                      </div>
                    </li>
                  ))}
                  <li className='logout_wrapper'>
                    <button
                      className='btn_logout_cd'
                      onClick={() => setShowLogoutPopup(true)}
                    >
                      ออกจากระบบ
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterMobile />
      <DangXuat
        showLogoutPopup={showLogoutPopup}
        setShowLogoutPopup={setShowLogoutPopup}
      />
      <ChamSocKhachHang
        isOpen={showChamSocKhachHang}
        setisOpen={setShowChamSocKhachHang}
      />
      <Loading isLoading={isLoading} />
    </div>
  )
}

export default CaiDatMobile
